export const CAPTAIN_ERROR_TYPES = Object.freeze({
  ABORTED: 'aborted',
  API_ERROR: 'api_error',
  HTTP_PREFIX: 'http_',
  ABORT_ERROR: 'AbortError',
  CANCELED_ERROR: 'CanceledError',
});

export const CAPTAIN_GENERATION_FAILURE_REASONS = Object.freeze({
  EMPTY_RESPONSE: 'empty_response',
  EXCEPTION: 'exception',
});
